import { NgModule } from '@angular/core';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { registerTranslationsManually } from '@skyeng/libs/shared/i18n';
import { I18nCommonService } from './i18n-common.service';
import { I18nConstantPipe } from './i18n-constant.pipe';

@NgModule({
  imports: [TranslocoModule],
  providers: [I18nCommonService],
  declarations: [I18nConstantPipe],
  exports: [I18nConstantPipe],
})
export class I18nCommonModule {
  constructor(private translocoService: TranslocoService) {
    registerTranslationsManually('common', this.translocoService, import.meta.webpackContext!('./translation'));
  }
}
